import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Brightness3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_3"}/>
}
